/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CreateFlagRequest = core.serialization.object({
    slug: core.serialization.string(),
    label: core.serialization.string(),
    colorHex: core.serialization.string(),
});
